import { observable, runInAction } from "mobx"

import { HasIdName } from "~/@shared/api-types/id-name-display"
import { MajorOccupation, MinorOccupation } from "~/api/_common/types-for-occupations"
import { fetchGetNewGradJobsMasterData } from "~/api/new-grad-jobs/master-data/get"

export default class MasterDataStore {
  @observable private isInitialized = false
  @observable private _majorOccupations: Array<MajorOccupation> = []
  @observable private _minorOccupations: Array<MinorOccupation> = []
  @observable private _regions: Array<HasIdName> = []
  @observable private _gradYears: Array<string> = []

  // NOTE: 以下のgetterは、一度undefinedが返却されるが、fetchの処理が終了後useObserverによって再レンダリングされる
  // このgetterによって、一度のみのfetchを実現する
  get majorOccupations() {
    if (!this.isInitialized) {
      this.fetch()
      return undefined
    }
    return this._majorOccupations
  }

  get minorOccupations() {
    if (!this.isInitialized) {
      this.fetch()
      return undefined
    }
    return this._minorOccupations
  }

  get regions() {
    if (!this.isInitialized) {
      this.fetch()
      return undefined
    }
    return this._regions
  }

  get gradYears() {
    if (!this.isInitialized) {
      this.fetch()
      return undefined
    }
    return this._gradYears
  }

  fetch = async () => {
    const res = await fetchGetNewGradJobsMasterData()

    runInAction(() => {
      const { major_occupations, minor_occupations, regions, grad_years } = res.data
      this.isInitialized = true
      this._majorOccupations = major_occupations
      this._minorOccupations = minor_occupations
      this._regions = regions
      this._gradYears = grad_years
    })
    return {
      majorOccupations: this._majorOccupations,
      minorOccupations: this._minorOccupations,
      regions: this._regions,
      gradYears: this._gradYears,
    }
  }
}
